"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2931],{

/***/ 98245:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ ModalProvider; },
/* harmony export */   "d": function() { return /* binding */ useModal; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var ModalContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)(null);
var ModalProvider = function(param) {
    var children = param.children, close = param.close;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ModalContext.Provider, {
        value: {
            close: close
        },
        children: children
    });
};
var useModal = function() {
    var context = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(ModalContext);
    if (context === null) {
        throw new Error("useModal must be used within a ModalProvider");
    }
    return context;
};


/***/ }),

/***/ 77391:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _modules_common_icons_spinner__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18000);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(86010);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);







var Button = function(_param) {
    var children = _param.children, className = _param.className, _isLoading = _param.isLoading, isLoading = _isLoading === void 0 ? false : _isLoading, _variant = _param.variant, variant = _variant === void 0 ? "primary" : _variant, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "children",
        "className",
        "isLoading",
        "variant"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props), {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)("w-full uppercase flex items-center justify-center min-h-[50px] px-5 py-[10px] text-small-regular border transition-colors duration-200 disabled:opacity-50 ", {
            "text-white bg-gray-900 border-gray-900 hover:bg-white hover:text-gray-900 disabled:hover:bg-gray-900 disabled:hover:text-white": variant === "primary",
            "text-gray-900 bg-transparent border-gray-920 hover:bg-gray-100": variant === "secondary"
        }, className),
        children: isLoading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_modules_common_icons_spinner__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {}) : children
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Button);


/***/ }),

/***/ 63269:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);




var Head = function(param) {
    var title = param.title, description = param.description, image = param.image, robots = param.robots, canonical = param.canonical, structuredData = param.structuredData, children = param.children;
    var ref;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var _NEXT_PUBLIC_VERCEL_URL;
    var url = (_NEXT_PUBLIC_VERCEL_URL = "https://akupanel-store.nl") !== null && _NEXT_PUBLIC_VERCEL_URL !== void 0 ? _NEXT_PUBLIC_VERCEL_URL : window === null || window === void 0 ? void 0 : (ref = window.location) === null || ref === void 0 ? void 0 : ref.origin;
    var defaultStructuredData = [
        {
            "@context": "https://schema.org",
            "@type": "Organization",
            url: "".concat(url),
            logo: "https://ik.imagekit.io/ik8qpq4jb/logo-akupanel-store.png?tr=pr-true,f-webp"
        },
        {
            "@context": "https://schema.org",
            "@type": "WebSite",
            url: "".concat(url),
            name: "Akupanel Store"
        }
    ];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "name",
                itemProp: "name",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                itemProp: "description",
                content: description !== null && description !== void 0 ? description : title
            }),
            image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                itemProp: "image",
                content: image
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "robots",
                content: robots !== null && robots !== void 0 ? robots : "index, follow"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "canonical",
                href: canonical && canonical.length > 1 ? canonical : url + router.asPath
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "icon",
                href: "/favicon.ico"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: "website"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: url + router.asPath
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:card",
                content: "summary_large_image"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:description",
                content: description !== null && description !== void 0 ? description : title
            }),
            image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:image",
                content: image
            }),
            image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: image
            }),
            children && children,
            defaultStructuredData.concat(structuredData !== null && structuredData !== void 0 ? structuredData : []).map(function(data, i) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                    type: "application/ld+json",
                    dangerouslySetInnerHTML: {
                        __html: JSON.stringify(data)
                    }
                }, "cs-".concat(i));
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Head);


/***/ }),

/***/ 1166:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ input; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@hookform/error-message/dist/index.esm.js
var index_esm = __webpack_require__(32866);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/modules/common/icons/eye.tsx





var Eye = function(_param) {
    var _size = _param.size, size = _size === void 0 ? "20" : _size, _color = _param.color, color = _color === void 0 ? "currentColor" : _color, attributes = (0,_object_without_properties/* default */.Z)(_param, [
        "size",
        "color"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: size,
        height: size,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, attributes), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M2.5 9.99992C2.5 9.99992 5.22727 4.58325 10 4.58325C14.7727 4.58325 17.5 9.99992 17.5 9.99992C17.5 9.99992 14.7727 15.4166 10 15.4166C5.22727 15.4166 2.5 9.99992 2.5 9.99992Z",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.99965 12.074C11.145 12.074 12.0735 11.1455 12.0735 10.0001C12.0735 8.85477 11.145 7.92627 9.99965 7.92627C8.85428 7.92627 7.92578 8.85477 7.92578 10.0001C7.92578 11.1455 8.85428 12.074 9.99965 12.074Z",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    }));
};
/* harmony default export */ var eye = (Eye);

;// CONCATENATED MODULE: ./src/modules/common/icons/eye-off.tsx





var EyeOff = function(_param) {
    var _size = _param.size, size = _size === void 0 ? "20" : _size, _color = _param.color, color = _color === void 0 ? "currentColor" : _color, attributes = (0,_object_without_properties/* default */.Z)(_param, [
        "size",
        "color"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: size,
        height: size,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, attributes), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8.56818 4.70906C9.0375 4.59921 9.518 4.54429 10 4.54543C14.7727 4.54543 17.5 9.99997 17.5 9.99997C17.0861 10.7742 16.5925 11.5032 16.0273 12.175M11.4455 11.4454C11.2582 11.6464 11.0324 11.8076 10.7815 11.9194C10.5306 12.0312 10.2597 12.0913 9.98506 12.0961C9.71042 12.101 9.43761 12.0505 9.18292 11.9476C8.92822 11.8447 8.69686 11.6916 8.50262 11.4973C8.30839 11.3031 8.15527 11.0718 8.05239 10.8171C7.94952 10.5624 7.899 10.2896 7.90384 10.0149C7.90869 9.74027 7.9688 9.46941 8.0806 9.2185C8.19239 8.9676 8.35358 8.74178 8.55455 8.55452M14.05 14.05C12.8845 14.9384 11.4653 15.4306 10 15.4545C5.22727 15.4545 2.5 9.99997 2.5 9.99997C3.34811 8.41945 4.52441 7.03857 5.95 5.94997L14.05 14.05Z",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M2.5 2.5L17.5 17.5",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    }));
};
/* harmony default export */ var eye_off = (EyeOff);

// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var dist_index_esm = __webpack_require__(87536);
;// CONCATENATED MODULE: ./src/modules/common/components/input/index.tsx










var Input = /*#__PURE__*/ react.forwardRef(function(_param, ref) {
    var type = _param.type, mainClassName = _param.mainClassName, name = _param.name, label = _param.label, errors = _param.errors, touched = _param.touched, required = _param.required, props = (0,_object_without_properties/* default */.Z)(_param, [
        "type",
        "mainClassName",
        "name",
        "label",
        "errors",
        "touched",
        "required"
    ]);
    var inputRef = react.useRef(null);
    var _$ref = (0,react.useState)(false), showPassword = _$ref[0], setShowPassword = _$ref[1];
    var _$ref1 = (0,react.useState)(type), inputType = _$ref1[0], setInputType = _$ref1[1];
    (0,react.useEffect)(function() {
        if (type === "password" && showPassword) {
            setInputType("text");
        }
        if (type === "password" && !showPassword) {
            setInputType("password");
        }
    }, [
        type,
        showPassword
    ]);
    (0,react.useImperativeHandle)(ref, function() {
        return inputRef.current;
    });
    var hasError = (0,dist_index_esm/* get */.U2)(errors, name) && (0,dist_index_esm/* get */.U2)(touched, name);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: mainClassName !== null && mainClassName !== void 0 ? mainClassName : "",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative z-0 w-full text-base-regular",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        type: inputType,
                        name: name,
                        placeholder: " ",
                        className: (0,clsx_m/* default */.Z)("pt-4 pb-1 block w-full px-4 mt-0 bg-transparent border appearance-none focus:outline-none focus:ring-0 focus:border-gray-400 border-gray-200", {
                            "border-rose-500 focus:border-rose-500": hasError
                        })
                    }, props), {
                        ref: inputRef
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                        htmlFor: name,
                        onClick: function() {
                            var _$ref;
                            return (_$ref = inputRef.current) === null || _$ref === void 0 ? void 0 : _$ref.focus();
                        },
                        className: (0,clsx_m/* default */.Z)("mx-3 px-1 transition-all absolute duration-300 top-3 -z-1 origin-0 text-gray-500", {
                            "!text-rose-500": hasError
                        }),
                        children: [
                            label,
                            required && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-rose-500",
                                children: "*"
                            })
                        ]
                    }),
                    type === "password" && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        type: "button",
                        onClick: function() {
                            return setShowPassword(!showPassword);
                        },
                        className: "text-gray-400 px-4 focus:outline-none transition-all duration-150 outline-none focus:text-gray-700 absolute right-0 top-3",
                        children: showPassword ? /*#__PURE__*/ (0,jsx_runtime.jsx)(eye, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(eye_off, {})
                    })
                ]
            }),
            hasError && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* ErrorMessage */.B, {
                errors: errors,
                name: name,
                render: function(param) {
                    var message = param.message;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "pt-1 pl-2 text-rose-500 text-xsmall-regular",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: message
                        })
                    });
                }
            })
        ]
    });
});
Input.displayName = "Input";
/* harmony default export */ var input = (Input);


/***/ }),

/***/ 95847:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _headlessui_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(84539);
/* harmony import */ var _headlessui_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(98831);
/* harmony import */ var _lib_context_modal_context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98245);
/* harmony import */ var _modules_common_icons_x__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47404);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(86010);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);






var Modal = function(param) {
    var isOpen = param.isOpen, close = param.close, _size = param.size, size = _size === void 0 ? "medium" : _size, children = param.children, _className = param.className, className = _className === void 0 ? "max-h-[65vh]" : _className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_4__/* .Transition */ .u, {
        appear: true,
        show: isOpen,
        as: react__WEBPACK_IMPORTED_MODULE_3__.Fragment,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_headlessui_react__WEBPACK_IMPORTED_MODULE_5__/* .Dialog */ .V, {
            as: "div",
            className: "relative z-[75]",
            onClose: close,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_4__/* .Transition.Child */ .u.Child, {
                    as: react__WEBPACK_IMPORTED_MODULE_3__.Fragment,
                    enter: "ease-out duration-300",
                    enterFrom: "opacity-0",
                    enterTo: "opacity-100",
                    leave: "ease-in duration-200",
                    leaveFrom: "opacity-100",
                    leaveTo: "opacity-0",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "fixed inset-0 bg-darkTone bg-opacity-75 backdrop-blur-sm"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "fixed inset-0 overflow-y-auto",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex min-h-full h-full items-center justify-center p-4 text-center",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_4__/* .Transition.Child */ .u.Child, {
                            as: react__WEBPACK_IMPORTED_MODULE_3__.Fragment,
                            enter: "ease-out duration-300",
                            enterFrom: "opacity-0 scale-95",
                            enterTo: "opacity-100 scale-100",
                            leave: "ease-in duration-200",
                            leaveFrom: "opacity-100 scale-100",
                            leaveTo: "opacity-0 scale-95",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_5__/* .Dialog.Panel */ .V.Panel, {
                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)("flex flex-col justify-start w-full transform overflow-hidden bg-white p-10 text-left align-middle shadow-xl transition-all", className, {
                                    "max-w-md": size === "small",
                                    "max-w-xl": size === "medium",
                                    "max-w-3xl": size === "large"
                                }),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_lib_context_modal_context__WEBPACK_IMPORTED_MODULE_1__/* .ModalProvider */ .D, {
                                    close: close,
                                    children: children
                                })
                            })
                        })
                    })
                })
            ]
        })
    });
};
var Title = function(param) {
    var children = param.children;
    var close = (0,_lib_context_modal_context__WEBPACK_IMPORTED_MODULE_1__/* .useModal */ .d)().close;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_headlessui_react__WEBPACK_IMPORTED_MODULE_5__/* .Dialog.Title */ .V.Title, {
        className: "flex items-center justify-between",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "text-large-semi",
                children: children
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                    onClick: close,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_modules_common_icons_x__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        size: 20
                    })
                })
            })
        ]
    });
};
var Description = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_5__/* .Dialog.Description */ .V.Description, {
        className: "flex text-small-regular text-gray-700 items-center justify-center pt-2 pb-4 h-full",
        children: children
    });
};
var Body = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "flex-1",
        children: children
    });
};
var Footer = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "flex items-center justify-end gap-x-4",
        children: children
    });
};
Modal.Title = Title;
Modal.Description = Description;
Modal.Body = Body;
Modal.Footer = Footer;
/* harmony default export */ __webpack_exports__["Z"] = (Modal);


/***/ }),

/***/ 18000:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);





var Spinner = function(_param) {
    var _size = _param.size, size = _size === void 0 ? "16" : _size, _color = _param.color, color = _color === void 0 ? "currentColor" : _color, attributes = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "size",
        "color"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        className: "animate-spin",
        width: size,
        height: size,
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24"
    }, attributes), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                className: "opacity-25",
                cx: "12",
                cy: "12",
                r: "10",
                stroke: color,
                strokeWidth: "4"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: "opacity-75",
                fill: color,
                d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Spinner);


/***/ }),

/***/ 47404:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);





var X = function(_param) {
    var _size = _param.size, size = _size === void 0 ? "20" : _size, _color = _param.color, color = _color === void 0 ? "currentColor" : _color, attributes = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "size",
        "color"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        width: size,
        height: size,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, attributes), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M15 5L5 15",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M5 5L15 15",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (X);


/***/ })

}]);